<template>
  <div>
    <Form
      :model="searchItem"
      :label-width="85"
      label-position="left"
      :disabled="modal_loading"
      ref="formValidate"
      :show-message="false"
      style="margin-top:20px"
    >
      <Row style="margin-bottom: 0">
        <Col :lg="8" :xs="18">
          <FormItem label="标签名称">
            <Input v-model="searchItem.chName" />
          </FormItem>
        </Col>
        <Col offset="1" :lg="2" :xs="2">
          <Button type="primary" @click="getData()">{{ $t("Search") }}</Button>
        </Col>
      </Row>
    </Form>
    <Table
      stripe
      border
      :columns="columns1"
      :loading="modal_loading"
      :data="dataTable"
    >
      <template slot="slot" slot-scope="{ row }">
        <div>
          <Icon
            @click="openPop(0, row)"
            type="md-eye"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
      <template slot="slot1" slot-scope="{ row }">
        <div>
          <Icon
            @click="openPop(1, row)"
            type="ios-people"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
      <template slot="slot2" slot-scope="{ row }">
        <div>
          <Icon
            @click="openPop(2, row)"
            type="ios-create"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
      <template slot="slot3" slot-scope="{ row }">
        <div>
          <Icon
            @click="openInternational(row)"
            type="md-globe"
            style="font-size: 30px;"
            color="#8CD29B"
          ></Icon>
        </div>
      </template>
    </Table>
    <Page
      :total="this.totalNum"
      style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:-10px"
      @on-change="pageChange"
    />
    <Modal
      width="55%"
      v-model="visualPop"
      :title="columns1[transferType + 1].title"
    >
      <TabsTransferComponent
        v-if="visualPop"
        :transferData="transferData"
        :transferTitle="transferTitle"
        @transferChange="transferChange"
      ></TabsTransferComponent>
      <div class="bottomBtn" slot="footer">
        <Button @click="cancel()">取消</Button>
        <Button type="primary" @click="saveData()" style="margin-left:15px"
          >保存</Button
        >
      </div>
    </Modal>
    <Modal v-model="showInternational" :title="showTitle" width="800px">
      <Table border :columns="columns2" :data="data2" :loading="loading">
        <!-- <template slot-scope="{ row, index }" slot="action">
              <Button type="primary" size="small" style="margin-right: 5px" @click="handleEdit(row, index)">编辑</Button>
              <Button type="primary" size="small" style="margin-right: 5px" @click="handleSave(row, index)">保存</Button>
            </template> -->
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total2"
            :page-size="pageInfo2.pageSize"
            @on-change="pageChange2"
          />
        </Col>
        <Col span="5" style="text-align:right;">
          <Button type="primary" @click="handleSaveAll">保存</Button>
        </Col>
      </Row>
      <div slot="footer">
        <!-- <Button type="text" @click="cancelClose()">取消</Button>
            <Button type="primary" @click="confirmSave()">确定</Button> -->
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import TabsTransferComponent from "./components/TabsTransferComponent";
export default {
  components: {
    TabsTransferComponent
  },
  data() {
    let t = this;
    return {
      searchItem: {},
      modal_loading: false,
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      columns1: [
        {
          title: "页签名称",
          key: "chName",
          align: "center"
        },
        {
          title: "可见内容",
          align: "center",
          slot: "slot"
        },
        {
          title: "可见角色",
          align: "center",
          slot: "slot1"
        },
        {
          title: "可编辑角色",
          align: "center",
          slot: "slot2"
        },
        {
          title: "国际化设定",
          align: "center",
          slot: "slot3"
        }
      ],
      dataTable: [],
      visualPop: false,
      transferData: [],
      transferTitle: "",
      updatedData: [],
      transferType: "",
      sheetId: "",
      sheetName: "",
      showInternational: false,
      showTitle: "",
      columns2: [
        {
          title: "中文名称",
          key: "chName",
          align: "center"
        },
        {
          title: "中文描述",
          key: "chName",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("Input", {
                props: {
                  type: "text",
                  // autofocus:true,
                  // disabled:(params.row.edit == true ? false : true),
                  value: params.row.chName
                },
                on: {
                  "on-blur"(value) {
                    t.data2[params.index].chName = value.target.value;
                  }
                }
              })
            ]);
          }
        },
        {
          title: "英文描述",
          key: "enName",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("Input", {
                props: {
                  type: "text",
                  // autofocus:true,
                  // disabled:(params.row.edit == true ? false : true),
                  value: params.row.enName
                },
                on: {
                  "on-blur"(value) {
                    t.data2[params.index].enName = value.target.value;
                  }
                }
              })
            ]);
          }
        }
        // {
        //   title: "操作",
        //   slot: 'action',
        //   width: "160",
        //   align: 'center',
        // }
      ],
      data2: [],
      pageInfo2: {
        pageNo: 1,
        pageSize: 10
      },
      total2: 0,
      loading: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // handleSave(row,index){
    //   let obj={
    //     chName: row.chName,
    //     enName: row.enName,
    //     sheetId: row.sheetId,
    //     showKey: row.showKey,
    //     sheetName: row.sheetName
    //   }
    //   axios.post("/FileInternationalViewSetController/updateSheetData", obj ).then((res) => {
    //     this.getIntennational()
    //   })
    // },
    handleSave() {
      this.loading = true;
      axios
        .post(
          "/FileInternationalViewSetController/updateAllSheetData",
          this.data2
        )
        .then(res => {
          this.loading = false;
          if (res) {
            this.$Message.success(this.$t("Save_Successful"));
          }
        });
    },
    handleSaveAll() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        onOk: () => {
          this.loading = true;
          axios
            .post(
              "/FileInternationalViewSetController/updateAllSheetData",
              this.data2
            )
            .then(res => {
              this.loading = false;
              if (res) {
                this.$Message.success(this.$t("Save_Successful"));
              }
            });
        }
      });
    },
    // handleEdit(row){
    //   row.edit = !row.edit
    // },
    getIntennational() {
      let obj = {
        sheetId: this.sheetId,
        pageNo: this.pageInfo2.pageNo,
        pageSize: this.pageInfo2.pageSize
      };
      axios
        .post("/FileInternationalViewSetController/selectSpecialData", obj)
        .then(res => {
          if (res) {
            this.data2 = res.data;
            this.total2 = Number(res.pageInfo.total);
          }
        });
    },
    openInternational(row) {
      this.showInternational = true;
      this.showTitle = row.chName;
      this.sheetId = row.sheetId;
      this.getIntennational();
    },
    pageChange2(val) {
      this.pageInfo2.pageNo = val;
      this.handleSave();
      this.getIntennational();
    },
    getData() {
      this.modal_loading = true;
      let json = {
        chName: this.searchItem.chName,
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      axios.post("/UserSheet/searchSheetSet", json).then(res => {
        this.modal_loading = false;
        if (res) {
          this.dataTable = res.data;
          this.totalNum = Number(res.pageInfo.total);
        }
      });
    },
    openPop(index, row) {
      this.visualPop = true;
      this.transferType = index;
      this.transferTitle = row.chName;
      this.sheetId = row.sheetId;
      this.sheetName = row.chName;
      if (index == 0) {
        this.searchSheetSet(row.sheetId);
      } else if (index == 1) {
        this.searchSheetPowerShowInfo(row.sheetId);
      } else {
        this.searchSheetPowerDisableSet(row.sheetId);
      }
    },
    //查询可见内容
    searchSheetSet(val) {
      let json = {
        sheetId: val,
        chName: ""
      };
      axios.post("/UserSheet/searchSheetSet", json).then(res => {
        if (res) {
          this.transferData = res.map(el => {
            return {
              ...el,
              key: el.showKey,
              label: el.chName,
              type: el.beShowUser
            };
          });
        }
      });
    },
    //查询可见角色
    searchSheetPowerShowInfo(val) {
      let json = {
        sheetId: val
      };
      axios
        .post("/SheetPowerShowSet/searchSheetPowerShowInfo", json)
        .then(res => {
          if (res) {
            this.transferData = res.map(el => {
              return {
                ...el,
                key: el.roleId,
                label: el.roleName,
                type: el.beVisible
              };
            });
          }
        });
    },
    //查询可编辑角色
    searchSheetPowerDisableSet(val) {
      let json = {
        sheetId: val
      };
      axios
        .post("/SheetPowerDisableSet/searchSheetPowerDisableSet", json)
        .then(res => {
          if (res) {
            this.transferData = res.map(el => {
              return {
                ...el,
                key: el.roleId,
                label: el.roleName,
                type: el.beVisible
              };
            });
          }
        });
    },

    transferChange(item) {
      this.updatedData = [];
      this.transferData.forEach(res => {
        if (this.transferType == 0) {
          res.beShowUser = "0";
          item.forEach(element => {
            if (res.showKey == element) {
              res.beShowUser = "1";
            }
          });
        } else if (this.transferType == 1) {
          item.forEach(element => {
            if (res.roleId == element) {
              this.updatedData.push({
                sheetId: this.sheetId,
                sheetName: this.sheetName,
                beShowRole: res.roleId
              });
            }
          });
        } else {
          console.log(item);
          item.forEach(element => {
            if (res.roleId == element) {
              this.updatedData.push({
                sheetId: this.sheetId,
                sheetName: this.sheetName,
                beDisableRole: res.roleId
              });
            }
          });
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    saveData() {
      if (this.transferType == 0) {
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "<p></p>",
          onOk: () => {
            axios
              .post("/UserSheet/updateSheetSet", this.transferData)
              .then(res => {
                if (res) {
                  this.$Message.info(res);
                  this.visualPop = false;
                }
              });
          },
          onCancel: () => {}
        });
      } else if (this.transferType == 1) {
        if (this.updatedData.length == 0) {
          this.updatedData.push({
            sheetId: this.sheetId,
            sheetName: this.sheetName
          });
        }
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "<p></p>",
          onOk: () => {
            axios
              .post(
                "/SheetPowerShowSet/updateSheetPowerShowInfo",
                this.updatedData
              )
              .then(res => {
                if (res) {
                  this.$Message.info(res);
                  this.visualPop = false;
                }
              });
          },
          onCancel: () => {}
        });
      } else {
        if (this.updatedData.length == 0) {
          this.updatedData.push({
            sheetId: this.sheetId,
            sheetName: this.sheetName
          });
        }
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "<p></p>",
          onOk: () => {
            axios
              .post(
                "/SheetPowerDisableSet/updateSheetPowerDisableSet",
                this.updatedData
              )
              .then(res => {
                if (res) {
                  this.$Message.info(res);
                  this.visualPop = false;
                }
              });
          },
          onCancel: () => {}
        });
      }
    },
    cancel() {
      this.visualPop = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/SystemSettings/EmployeeFilesSetting.vue